import React from "react";
import U2000InputTagAlpha from "./U2000InputTagAlpha";
import U2000InputTagAlphanum from "./U2000InputTagAlphanum";
import U2000InputTagNumeric from "./U2000InputTagNumeric";
import U2000InputTagDate from "./U2000InputTagDate";
import type { U2000FormStateHandlers } from "../../../reducer/formReducer/U2000FormStateHandlers";

/**
 * Liste des types d'input acceptés pour U2000InputTag.
 */
export const U2000InputTagEnum = {
  ALPHANUM: "alphanum",
  ALPHA: "alpha",
  NUMERIC: "numeric",
  DATE: "date",
} as const;
export type U2000InputTagType = (typeof U2000InputTagEnum)[keyof typeof U2000InputTagEnum];

export interface U2000InputTagProps {
  formStateHandlers: U2000FormStateHandlers<any>;
  fieldName: string;
  label: string;
  readonly?: boolean;
  required?: boolean;
  formatter?: (value: any) => any;
  inputType?: U2000InputTagType;
  placeholder?: string;
  icon?: React.ReactNode;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  /** Contenu à droite du champ tags, aligné verticalement au centre avec l’input. */
  inlineEnd?: React.ReactNode;
}

const U2000InputTag: React.FC<U2000InputTagProps> = (props) => {
  switch (props.inputType) {
    case U2000InputTagEnum.ALPHA:
      return <U2000InputTagAlpha {...props} />;
    case U2000InputTagEnum.ALPHANUM:
      return <U2000InputTagAlphanum {...props} />;
    case U2000InputTagEnum.NUMERIC:
      return <U2000InputTagNumeric {...props} />;
    case U2000InputTagEnum.DATE:
      return <U2000InputTagDate {...props} />;
    default:
      return <U2000InputTagAlpha {...props} />;
  }
};

export default U2000InputTag;
